// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/betrakta_pbr.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'betrakta_pbrPixelShader';
const shader = `varying vec3 vWorldPosition;
varying vec2 vUV;
varying vec3 vNormal;
varying vec4 vTangent;
uniform sampler2D diffuseTexture, normalTexture;
uniform samplerCube environmentMap;
uniform float environmentMapIntensity;
uniform vec4 diffuseColorFactor;
uniform float exposure;
uniform float alphaCutoff;
uniform vec3 uvTransform0, uvTransform1;
vec4 toLinearSpace(vec4 rgba) {
return vec4(pow(rgba.xyz, vec3(2.2)), rgba.a);
}
uniform vec3 lightDirection, lightPosition, lightColor;
uniform vec2 lightValues;
uniform vec3
diffuseSH_L00,
diffuseSH_L1_1,
diffuseSH_L10,
diffuseSH_L11,
diffuseSH_L2_2,
diffuseSH_L2_1,
diffuseSH_L20,
diffuseSH_L21,
diffuseSH_L22;
vec3 computeEnvironmentIrradiance(vec3 normal) {
return diffuseSH_L00
+ diffuseSH_L1_1*(normal.y)
+ diffuseSH_L10*(normal.z)
+ diffuseSH_L11*(normal.x)
+ diffuseSH_L2_2*(normal.y*normal.x)
+ diffuseSH_L2_1*(normal.y*normal.z)
+ diffuseSH_L20*((3.0*normal.z*normal.z)-1.0)
+ diffuseSH_L21*(normal.z*normal.x)
+ diffuseSH_L22*(normal.x*normal.x-(normal.y*normal.y));
}
vec3 ditherR11G11B10F(vec3 color);
void main() {
mat3x2 uvMatrix = mat3x2(uvTransform0.x, uvTransform1.x, uvTransform0.y, uvTransform1.y, uvTransform0.z, uvTransform1.z);
vec2 uv = uvMatrix * vec3(vUV, 1.0);
vec4 albedo = toLinearSpace(texture(diffuseTexture, uv));
albedo *= diffuseColorFactor;
if (albedo.a < alphaCutoff) discard;
vec3 normalMapData = texture(normalTexture, uv).rgb * 2.0 - 1.0;
vec3 bitangent = cross(vNormal, vTangent.xyz) * vTangent.w;
mat3 tbn = mat3(
vTangent.xyz,
bitangent,
vNormal
);
vec3 normal = normalize(tbn * normalMapData);
vec3 diffuse = vec3(0.0);
vec3 L = lightPosition - vWorldPosition;
float Ld2 = dot(L, L);
L /= sqrt(Ld2);
float lightDot = max(0.0, dot(normal, L));
diffuse += albedo.xyz * lightColor * smoothstep(lightValues.x, lightValues.y, dot(L, -lightDirection)) * lightDot / Ld2;
diffuse += computeEnvironmentIrradiance(normal) * albedo.xyz * environmentMapIntensity / 3.1415926536;
gl_FragColor = vec4(diffuse * exposure, albedo.a);
const mat3 ACESInputMat = mat3(
vec3(0.59719, 0.07600, 0.02840),
vec3(0.35458, 0.90834, 0.13383),
vec3(0.04823, 0.01566, 0.83777)
);
gl_FragColor.rgb = ACESInputMat * gl_FragColor.rgb;
gl_FragColor.rgb = ditherR11G11B10F(gl_FragColor.rgb);
}
float R2(vec2 f) {
const vec2 alpha = 1.0 / vec2(1.324717958, 1.324717958*1.324717958);
float I = fract(alpha.x * f.x + alpha.y * f.y);
return I;
}
vec3 ditherR11G11B10F(vec3 color) {
float dither = R2(gl_FragCoord.xy) * 2.0 - 1.0;
vec3 quantum = exp2(floor(log2(color)) - vec3(6.0, 6.0, 5.0));
return color + quantum * dither;
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const betrakta_pbrPixelShader = { name, shader };
//# sourceMappingURL=betrakta_pbr.fragment.js.map